<div *ngIf="alerts.length > 0">
    <div uib-alert [ngClass]="getListClass()">
        <div *ngFor="let alert of alerts; trackBy: trackByFn">
            <general-alert [alert]="alert"></general-alert>
        </div>
    </div>
</div>
